import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TagMismatchAndReplace } from './pages';

export const TagMismatchAndReplaceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={TagMismatchAndReplace} />
    </Fragment>
)